import React, { useContext } from 'react';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import Stack, { contentStackSpacing } from '../Stack';
import { StyleProp, View, ViewStyle } from 'react-native';
import { maxFormWidth } from './CenteredFormRow';
import { ForceStackFieldsContext } from './ForcedStackFieldsContext';

export type SplitFormRowOwnProps = {
    children: React.ReactNode | [React.ReactNode, React.ReactNode];
    styleLeft?: StyleProp<ViewStyle>;
    styleRight?: StyleProp<ViewStyle>;
};

export type SplitFormRowProps = SplitFormRowOwnProps;

const SplitFormRow: React.FC<SplitFormRowProps> = (props) => {
    const forceStackFields = useContext(ForceStackFieldsContext);
    const isMobile = useIsMobileLayout();

    if (isMobile || forceStackFields) {
        return (
            <Stack vertical fullWidth space={contentStackSpacing} align="center">
                {props.children}
            </Stack>
        );
    }

    const renderSplitContainer = (child: React.ReactNode, index: number) => {
        return (
            <Stack
                horizontal
                flex={1}
                justify={index === 0 ? 'flex-start' : 'flex-end'}
                space={contentStackSpacing}
                key={index}
                style={index === 0 ? props.styleLeft : props.styleRight}
            >
                {child}
            </Stack>
        );
    };

    const childrenAsArray = React.Children.toArray(props.children);
    if (childrenAsArray.length === 1) {
        childrenAsArray.push(<View />);
    }

    return (
        <Stack horizontal fullWidth space={contentStackSpacing} justify="center">
            <Stack
                horizontal
                fullWidth
                space={20}
                align="flex-start"
                justify="space-between"
                style={{
                    maxWidth: maxFormWidth,
                }}
            >
                {childrenAsArray.map(renderSplitContainer)}
            </Stack>
        </Stack>
    );
};

export default React.memo(SplitFormRow);
